export default class AttachmentPolicy {
    constructor(gate) {
        this.gate = gate;
    }

    browse(user, document) {
        return this.gate.allow('read', 'document', document);
    }

    add(user, document) {
        return this.gate.allow('edit', 'document', document);
    }

    download(user, attachment, document) {
        return this.gate.allow('read', 'document', document);
    }

    destroy(user, attachment, document) {
        return this.gate.allow('edit', 'document', document);
    }
}
